
import Vue from "vue";
import PartsDesignerLayout from "./internal/PartsDesignerLayout.vue";
import PartsChooser from "./internal/PartsChooser.vue";
import ShapesChooser from "./internal/ShapesChooser.vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { DesignContext, DraggingContext, LayoutConfig, Parts } from "./types";

@Component({
    name: "parts-designer",
    components: { PartsDesignerLayout, PartsChooser, ShapesChooser },
})
export default class PartsDesigner extends Vue {
    @Prop({ type: Object }) template!: webpartv3.WebpartTemplate;
    @Prop({ type: Object }) layout!: LayoutConfig;
    @Prop({ type: Array }) value!: Parts;
    @Prop({ type: Boolean, default: false }) personal!: boolean;

    dragging: DraggingContext = {
        active: false,
        cancelled: false,
        id: 0,
        part: Object.create(null),
    };

    context: DesignContext = {
        selected: Object.create(null),
    };

    /**
     * Column 개수를 초기화 합니다.
     */
    public minColumns() {
        const comp: PartsDesignerLayout = this.$refs.designer as any;
        return comp.minColumns();
    }

    /**
     * Row 개수를 초기화 합니다.
     */
    public minRows() {
        const comp: PartsDesignerLayout = this.$refs.designer as any;
        return comp.minRows();
    }
}
